module.exports = __webpack_public_path__ + "img/img_logo_sm_hip.288900c7.svg";